module.exports = __webpack_public_path__ + "static/img/iphone-x-mockup-horizontal.2e0b51f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/iphone-x-mockup-horizontal.png
// module id = VV87
// module chunks = 1